import Intro from "../../components/intro/Intro";
import Gallery from "../../components/gallery/Gallery";
import Note from "../../components/note/Note";

const AnimalCrossing = () => {
  const me = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/cherry_blossom_stroll.jpg",
      alt: "a dreamy stroll through cherry blossoms",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/nerd.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/cottage.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/frolick.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/flower_girl.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/secret_picnic.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/cherry_blossom_bridge.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/tea.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/cherry_blossoms.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/drowning.JPG",
      alt: "me",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/bff_room.jpg",
      alt: "me",
    },
  ];

  const villagers = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/deirdre.JPG",
      alt: "deirdre",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/pate.JPG",
      alt: "pate",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/marina.jpg",
      alt: "marina",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/alfonso.jpg",
      alt: "alfonso",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/gladys.JPG",
      alt: "gladys",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/alfonso2.jpg",
      alt: "alfonso",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/ladies.jpg",
      alt: "pate, marina, and gladys",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/alfonso3.jpg",
      alt: "alfonso",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/pate2.jpg",
      alt: "pate",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/alfonso4.jpg",
      alt: "alfonso",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/deirdre2.jpg",
      alt: "deirdre",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/merengue.jpg",
      alt: "merengue",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/me_and_tucker.jpg",
      alt: "merengue",
    },
  ];

  const npcs = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/kicks.jpg",
      alt: "kicks",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/brewster.JPG",
      alt: "brewster",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/gullivarrr.JPG",
      alt: "gullivarrr",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/kappn.jpg",
      alt: "kappn",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/roost.JPG",
      alt: "roost",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/timmy_tommy.JPG",
      alt: "timmy + tommy",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/kappn2.jpg",
      alt: "kappn",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/able_sisters.jpg",
      alt: "able sisters",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/animal_crossing/evil.JPG",
      alt: "timmy + tommy",
    },
  ];

  return (
    <>
      <Intro
        primary="ANIMAL CROSSING"
        secondary="This is one of my all-time favorite video games. I spend a lot of time doing something unusual: planning, staging, taking, and editing pictures using the in-game camera (and other tools). If you want to explore my gallery..."
        tertiary="You're in the right place."
      />

      <div className="column p01 g1">
        <h2>ME</h2>
        <Gallery pictures={me} />

        <h2>VILLAGERS</h2>
        <Gallery isHalf pictures={villagers} />

        <h2>STAFF</h2>
        <Gallery isHalf pictures={npcs} />

        <Note type="note" header="FUN FACT" style={{ margin: "1rem 0" }}>
          <p>
            Nintendo once asked if they could use my pictures in their marketing
            and advertising efforts on Reddit. I said no.
          </p>
        </Note>
      </div>
    </>
  );
};

export default AnimalCrossing;
